import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Settings } from "../../components/mail/Settings";
import { useUser } from "../../context/UserContext";

function SettingsView() {
  const navigate = useNavigate();
  const { userInfo } = useUser();
  const { mailboxes = [] } = useOutletContext() || {};

  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  const userEmail = userInfo?.email || "";

  return (
    <>
      <Helmet>
        <title>Settings - {userEmail || "Grigora Mail"}</title>
      </Helmet>
      <Settings onClose={handleClose} userInfo={userInfo} mailboxes={mailboxes} />
    </>
  );
}

export default SettingsView;

